import { captureException, captureMessage } from '@sentry/react';
import { QueryClient } from 'react-query';

const onError = (error: unknown) => {
  const httpError = error as { status: number; message: string };
  if (httpError.status >= 500) {
    // Report only server-side issues
    captureException(error, {
      tags: { type: 'server-error', status: httpError.status },
    });
  } else if (httpError.status === 404 || httpError.status === 412) {
    console.warn(httpError);
  } else if (httpError.status >= 400) {
    captureMessage(`Client error: ${httpError.status}`, {
      level: 'warning',
    });
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // force refetch on every query
      staleTime: 0,
      // don't cache queries
      cacheTime: 0,
      onError,
    },
    mutations: {
      onError,
    },
  },
});
